import { useEffect } from 'react';

import { useFormikContext } from 'formik';

import { useLojaStepContext } from 'pages/cadastro/loja/contexts';

export function LojaFormDirtyListener() {
    const { activeStep, setActiveStepDirty } = useLojaStepContext();
    const { dirty } = useFormikContext();

    useEffect(() => {
        if (dirty !== activeStep.fgDirty) {
            setActiveStepDirty(dirty);
        }
    }, [dirty]);

    return null;
}
